// extracted by mini-css-extract-plugin
module.exports = {"root":"PrivacyPolicy_root__15OWR","lastUpdated":"PrivacyPolicy_lastUpdated__hyDsE"};